export const _rootConfig = "_rootConfig";
export const newRouteKey = "new";
export const defaultRoute = "default";